<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Edit Quote</h1>

    <div class="bg-white rounded-md shadow p-6">
      <form @submit.prevent="submit">
        <div class="mb-6">
          <text-input v-model="form.game" class="pr-6 pb-4 w-full" label="Game (optional)" />
          <text-input v-model="form.contributor" class="pr-6 pb-4 w-full" label="Contributor (optional)" />

          <label class="block text-gray-700">Date Added</label>
          <input v-model="form.added_at" type="date" class="form-input mt-1 block w-full mb-4" />

          <label class="block text-gray-700">Quote</label>
          <textarea v-model="form.quote_text" rows="6" class="form-textarea mt-1 block w-full"></textarea>
          <div v-if="form.errors.quote_text" class="text-red-500 mt-2">{{ form.errors.quote_text }}</div>
        </div>

        <div class="flex items-center">
          <button type="submit" class="btn-indigo mr-4">Save</button>
          <button class="btn-red mr-4" @click.prevent="destroy">Delete</button>
          <inertia-link :href="route('quotes')" class="text-sm text-gray-600">Cancel</inertia-link>
          <inertia-link v-if="quote.deleted_at" @click.prevent="restore" :href="route('quotes.restore', quote.id)" class="text-sm text-indigo-500 ml-6">Restore</inertia-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'

export default {
  components: { TextInput },
  layout: Layout,
  metaInfo: { title: 'Edit Quote' },
  props: {
    quote: Object,
  },
  data() {
    return {
      form: {
        quote_text: this.quote.quote_text,
        game: this.quote.game || '',
        contributor: this.quote.contributor || '',
        added_at: this.quote.added_at ? String(this.quote.added_at).substr(0,10) : '',
        errors: {},
      },
    }
  },
  methods: {
    submit() {
      this.$inertia.put(this.route('quotes.update', this.quote.id), {
        quote_text: this.form.quote_text,
        game: this.form.game,
        contributor: this.form.contributor,
        added_at: this.form.added_at,
      })
    },

    destroy() {
      this.$inertia.delete(this.route('quotes.destroy', this.quote.id))
    },
    restore() {
      this.$inertia.put(this.route('quotes.restore', this.quote.id))
    },
  },
}
</script>
